/* eslint-disable max-len */

export const conditionOptions = [
  {
    value: 'condition_1',
    description:
      '1. Unique spare parts are articles made specifically as a part or component of a particular assembly and are produced only by the manufacturer of the assembly.',
  },
  {
    value: 'condition_2',
    description:
      '2. Personal safety devices and emergency equipment which are duplicates of equipment needed to sustain life justified on safety grounds - by the need for equipment uniformity, and the need to train personnel in the use of such equipment.',
  },
  {
    value: 'condition_3',
    description:
      '3. Samples for testing purchased from a specific vendor for the purpose of conducting tests to determine their suitability for a particular use.',
  },
  {
    value: 'condition_4',
    description:
      '4. Warranty repair work procured from the manufacturer or vendor from whom the goods were originally purchased to comply with existing warranty coverage. Please attach existing warranty documentation from vendor.',
  },
  {
    value: 'condition_5',
    description:
      '5. Replacement material for items lost or damaged in transit, storage or start-up, when purchased from the original vendor.',
  },
  {
    value: 'condition_6',
    description:
      '6. Modification/refurbishment of capital equipment when the requester substantiates that this is an economic alternative to replacement.',
  },
  {
    value: 'condition_7',
    description:
      '7. Customer specifications may prescribe only one source that is competent to perform a service or service of a named manufacturer or vendor, excluding all others.',
  },
  {
    value: 'condition_8',
    description:
      '8. Product/material managed by solo distributor, dealer, import agent (e.g., vehicle, specific brand product etc.)',
  },
]
